"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _Button = require("../Button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Banner = function Banner(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$dismissable = _ref.dismissable,
    dismissable = _ref$dismissable === void 0 ? false : _ref$dismissable,
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? _lodash.noop : _ref$hide;
  // "app-banner" class is only here to keep ScrollTo functionality from utils, not used for styling anymore
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('app-banner flex relative items-center justify-center tw-label-light min-h-[50px] px-[48px] bg-blue1-70 text-white', className)
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "my-[20px]"
  }, children), dismissable && /*#__PURE__*/_react.default.createElement(_Button.IconButton, {
    className: "absolute right-[20px]",
    icon: "close-24",
    onClick: hide
  }));
};
exports.Banner = Banner;